import { render, staticRenderFns } from "./MyDocuments.vue?vue&type=template&id=8e42c7e4&scoped=true&"
import script from "./MyDocuments.vue?vue&type=script&lang=js&"
export * from "./MyDocuments.vue?vue&type=script&lang=js&"
import style0 from "./MyDocuments.vue?vue&type=style&index=0&id=8e42c7e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e42c7e4",
  null
  
)

export default component.exports